// Hook dodania komentarza do oferty (nagłówka).
// POST /sales-crm/clients/:cid/offers/:oid/comments

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IPostSalesCrmOfferCommentPayload {
  comment: string;
  isVisibleForClient?: boolean;
  fileBase64?: string | null;
  fileName?: string | null;
}

type IResponse = ICommandResponseSuccess & { id?: number };

const postSalesCrmOfferComment = (
  clientId: number,
  offerId: string,
  payload: IPostSalesCrmOfferCommentPayload
): Promise<IResponse> =>
  axios.post(`/sales-crm/clients/${clientId}/offers/${offerId}/comments`, payload);

export const usePostSalesCrmOfferComment = (
  clientId: number,
  offerId: string,
  options?: UseMutationOptions<IResponse, IError, IPostSalesCrmOfferCommentPayload>
) =>
  useMutation(
    (payload: IPostSalesCrmOfferCommentPayload) =>
      postSalesCrmOfferComment(clientId, offerId, payload),
    options
  );
